import { liveVersion } from 'src/components/star-grid/utils/versionCatalog';
import { SelectProps } from '@amzn/awsui-components-core/select';
import { PnlDataVersion, PnlDeckGroup } from 'src/components/star-grid/reportSelectors.types';
import { PnlReportConfig } from 'src/components/star-grid/starGridTypes';

export const versionOptions = (versions: readonly PnlDataVersion[], unavailable: string): SelectProps.Options =>
  versions.map((version) => ({
    value: version.version,
    label: version.label,
    ...(version.resolvable === false ? { disabled: true, description: unavailable } : {})
  }));

export const selectedVersionOption = (versions: readonly PnlDataVersion[], timestamp?: string): SelectProps.Option | null => {
  const selected = timestamp ? versions.find((version) => version.as_of === timestamp) : liveVersion(versions);
  if (selected) return { value: selected.version, label: selected.label };
  return timestamp ? { value: timestamp, label: timestamp } : null;
};

const catalogKey = (value?: string | null): string => (value ?? '').trim().toLowerCase();
/**
 * Deck options for the WW Report's Deck selector, keyed by deck TYPE -- not by report row.
 *
 * A deck is offered when it has config, whether or not a report was ever created against it:
 * selecting one re-renders the CURRENT report as that deck (the query and config endpoints take a
 * deck_type), so a separate report row per deck is not needed. Keying on report_id instead listed
 * only decks with a report -- which was just MEC -- and made selection navigate away rather than
 * re-render. The option value is the deck_type the caller passes back to the query.
 */
export const deckOptions = (groups: readonly PnlDeckGroup[], definition: PnlReportConfig | undefined, unassigned: string): SelectProps.Options => {
  if (!definition) return [];
  const current = groups.find((group) => group.reports.some((report) => report.pnl_report_id === definition.pnl_report_id));
  const category = catalogKey(definition.deck_report ?? current?.deck_report);
  const seen = new Map<string, string>();
  for (const group of groups.filter((entry) => catalogKey(entry.deck_report) === category)) {
    const key = catalogKey(group.deck_type);
    if (key && !seen.has(key)) seen.set(key, group.deck_type?.trim() || unassigned);
  }
  return [...seen.entries()].map(([value, label]) => ({ value, label }));
};
